<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<div class="header-container">
			<div class="search-swiper-container">
				<Swiper :list="banners"/>
			</div>
		</div>
		<div class="content">
			<div class="wrapper">
				<div class="pic-video-list" v-if="showList">
					<div class="item-wrapper">
						<div class="body">
							<Loading :is-loading="isPicLoading"></Loading>
							<div class="img-item" v-for="item in cateList" :key="item.id" @click="toCate(item.id)">
								<img class="img" :src="item.thumb" oncontextmenu="return false" :alt="item.title"/>
								<div class="title"><span>{{ item.title }}</span></div>
							</div>
						</div>
						<div class="loadmore">
							<span class="end" v-if="!isPicLoading">- {{$t('theEnd')}} -</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import international_cates from './international_cates_controller';
export default international_cates;
</script>

<style src="@/assets/css/active_list.css" scoped></style>
